module.exports = __webpack_public_path__ + "buyer-wide.jpg?1399cfa9efef86441b0d2124fcfeeee2";